export default {
  ' ': `
    [6,8]
  `,
  '-': `
    [6,8]



     +++++



  `,
  '=': `
    [6,8]


     +++++

     +++++


  `,
  '+': `
    [6,8]

       +
       +
     +++++
       +
       +

  `,
  '.': `
    [6,8]





      ++
      ++
  `,
  ':': `
    [6,8]


       +


       +

  `,
  '#': `
    [6,8]
      + +
      + +
     +++++
      + +
     +++++
      + +
      + +
  `,
  '?': `
    [6,8]
      +++
     +   +
         +
        +
       +

       +
  `,
  '(': `
    [6,8]
        +
       +
      +
      +
      +
       +
        +
  `,
  ')': `
    [6,8]
      +
       +
        +
        +
        +
       +
      +
  `,
}



// WEBPACK FOOTER //
// ./src/dot-fonts/symbols.js